<template lang="pug">
.main
  top-bar
  v-container(style="max-width: 500px;")
    h1.text-center.mt-8.mb-4.grey--text.text--darken-3(v-if="company && !this.$isLandingPage") Sign in to {{ company.name }}
    h1.text-center.my-8.grey--text.text--darken-3(v-else) Sign in
    p.text-center.title.pb-4(v-if="!$isLandingPage && $subdomain") {{ $subdomain }}.yezza.io
    v-card.mt-4.px-2.py-4(v-if="step === 1" outlined :tile="$vuetify.breakpoint.xs" :class="{'px-8': !$vuetify.breakpoint.xs}")
      v-card-text(:class="{'pb-0': $vuetify.breakpoint.xs}")
        v-text-field(color="primary" v-model="phoneEmail" label="Phone number or e-mail address" outlined @keyup.enter="continueSignIn" :disabled="emailInputDisabled")
        v-btn.mb-4.font-weight-bold(color="accent" x-large block depressed @click="continueSignIn" :loading="loading") Continue
    v-card.mt-4.px-2.py-4(v-if="step === 2" outlined :tile="$vuetify.breakpoint.xs" :class="{'px-8': !$vuetify.breakpoint.xs}")
      v-card-text(:class="{'pb-0': $vuetify.breakpoint.xs}")
        v-text-field(color="primary" v-model="phoneEmail" label="Phone number or e-mail address" hide-details outlined disabled)
          v-icon(color="green lighten-1" slot="append") mdi-check-circle
        template(v-if="emailAuthInProgress")
          v-row(v-if="emailAuthWaiting")
            v-col.shrink.pr-0
              v-progress-circular.mb-1(indeterminate :size="15" :width="2")
            v-col.grow
              span Waiting for your approval...
          v-row(v-else)
            template(v-if="emailAuthSuccess")
              v-col.shrink.pr-0
                v-icon.mb-1(color="green lighten-1" slot="append" small) mdi-check-circle
              v-col.grow
                div Sign in approved. Continue in {{emailAuthCloseTimer}}...
            template(v-else)
              v-col.shrink.pr-0
                v-icon.mb-1(color="red lighten-1" slot="append" small) mdi-close-circle
              v-col.grow
                div Approval link has expired,&nbsp;
                  a(@click="requestEmailAuthLink") click here to request again
                  | .
        v-text-field.mt-4(color="primary" v-model="form.password" type="password" label="Password" outlined @keyup.enter="passwordSignIn" persistent-hint)
        v-btn.mb-4.font-weight-bold(color="accent" x-large block depressed @click="passwordSignIn" :loading="passwordSignInLoading") Sign In
        .text-center
          a(@click="$router.push({ name: 'Forgot', params: { signInEmail: form.email } })") Forgot password?
        .text-center.mt-2
          a(@click="step--") &#8592; Back
  .modals
    y-dialog(v-model='phoneAuthInProgress' persistent width='300')
      v-card(v-if="phoneAuthWaiting" color='primary' dark)
        v-card-text.pt-3
          p.mt-2 Check your phone. We've sent a SMS with an approval link to {{phoneEmail}}.
          v-progress-linear.my-4(indeterminate='', color='white')
          p.mb-0.caption Waiting for your approval...
      template(v-else)
        v-card(v-if="phoneAuthSuccess" color='success' dark)
          v-card-text.pt-3
            p.mt-2 Sign in approved
            v-progress-linear.my-4(indeterminate='', color='white')
            p.mb-0.caption Continue in {{phoneAuthCloseTimer}}...

        v-card(v-else color='error' dark)
          v-card-text.pt-3
            p.mt-2 Sign in not approved in time
            v-progress-linear.my-4(indeterminate='', color='white')
            p.mb-0.caption Closing in {{phoneAuthCloseTimer}}...
</template>

<script>
  import Cookies from 'js-cookie'
  import {mapState, mapGetters, mapActions} from 'vuex'
  import TopBar from '@/components/TopBar.vue'
  export default {
    name: "SignIn",
    components: { TopBar },
    props: ['fillEmail', 'invitation'],
    data: (vm) => ({
      loading: false,
      passwordSignInLoading: false,
      step: 1,
      emailInputDisabled: false,
      phoneEmail: vm.fillEmail,
      form: {
        password: '',
      },
      phoneAuthInProgress: false,
      phoneAuthWaiting: false,
      phoneAuthSuccess: false,
      phoneAuthProgressTimer: 0,
      phoneAuthCloseTimer: 0,
      emailAuthInProgress: false,
      emailAuthWaiting: false,
      emailAuthSuccess: false,
      emailAuthProgressTimer: 0,
      emailAuthCloseTimer: 0
    }),
    computed: {
      ...mapState('user', ['user']),
      ...mapGetters({
        company: 'getCompany'
      }),
      authMethod () {
        if (this.phoneEmail) {
          return this.phoneEmail.includes('@') ? 'email': 'phone'
        } else {
          return 'phone'
        }
      }
    },
    watch: {
      phoneAuthCloseTimer (val) {
        if (val === 0) {
          this.phoneAuthInProgress = false
        }
      }
    },
    mounted () {
      if (this.$route.query.email) {
        this.phoneEmail = this.$route.query.email
        this.form.email = this.phoneEmail
        this.step = 2
      } else if (this.$route.query.phone) {
        this.phoneEmail = this.$route.query.phone
        this.form.phone = this.phoneEmail
        this.step = 2
      }

      if (this.$route.query.key) {
        this.form.password = this.$route.query.key
        this.passwordSignIn()
      }
    },
    methods: {
      ...mapActions(['showMessage']),
      continueSignIn () {
        if (this.authMethod === 'phone') {
          this.phoneSignIn()
        } else if (this.authMethod === 'email') {
          this.emailSignIn()
        }
      },
      async phoneSignIn () {
        this.loading = true
        try {
          let resp = await this.$axios.get(`/users/check_phone/?phone=${encodeURIComponent(this.phoneEmail)}`)
          if (!resp.data.available) {
            this.form.phone = this.phoneEmail
            this.step = 2
          } else {
            this.showMessage(['error', this.$t('error_message.no_account_associated_phone')])
          }
        } catch {
          this.showMessage(['error', this.$t('error_message.no_account_associated_phone')])
        } finally {
          this.loading = false
        }
      },
      async emailSignIn () {
        this.loading = true
        try {
          let resp = await this.$axios.get(`/users/check_email/?email=${encodeURIComponent(this.phoneEmail)}`)
          if (!resp.data.available) {
            this.form.email = this.phoneEmail
            this.step = 2
          } else {
            this.showMessage(['error', this.$t('error_message.no_account_associated_email')])
          }
        } catch {
          this.showMessage(['error', this.$t('error_message.no_account_associated_email')])
        } finally {
          this.loading = false
        }
      },
      async passwordSignIn () {
        this.passwordSignInLoading = true
        try {
          let resp = await this.$axios.post('/users/token/', this.form)
          this.completeSignIn(resp.data, 'password')
        } catch {
          this.showMessage(['error', this.$t('error_message.invalid_email_phone_password')])
        } finally {
          this.passwordSignInLoading = false
        }
      },
      completeSignIn (respData, signInMethod = null) {
        this.$store.commit('user/setUser', respData)
        this.$axios.defaults.headers.common['Authorization'] = `Token ${respData.token}`
        if (signInMethod) {
          this.$logEvent('user.signed_in', { method: signInMethod })
        }
        if (this.$isLandingPage || !this.$subdomain) {
          this.$router.push('/admin')
        } else {
          let cookieNextPath = Cookies.get('yz_next_path')
          if (cookieNextPath) {
            this.$router.push(cookieNextPath)
            this.$store.commit('ui/setRedirectPath', null)
          } else {
            this.$router.push('/admin/dashboard')
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>